import React from 'react';
import PropTypes from 'prop-types';

const AccessibilityBypassBlock = ({ id, text }) => {
   
    const handleClick = e => {
        e.preventDefault(); // Prevent the default anchor click behavior
        const currentUrl = window.location.origin + window.location.pathname;
        window.location.href = `${currentUrl}#${id}`;
      }

    return (
        <a href={`#${id}`} id='skip-link' className="SkipLink" tabIndex="0" onClick={handleClick}>{text || `Skip to ${id} contetn`}</a>
    );
};

AccessibilityBypassBlock.propTypes = window.config.developMode ? {
    id: PropTypes.string.isRequired
} : {};

export default AccessibilityBypassBlock;
